import { render, staticRenderFns } from "./TiptapDynamicValue.vue?vue&type=template&id=19c1e0cc"
import script from "./TiptapDynamicValue.vue?vue&type=script&lang=js"
export * from "./TiptapDynamicValue.vue?vue&type=script&lang=js"
import style0 from "./TiptapDynamicValue.vue?vue&type=style&index=0&id=19c1e0cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports